<template>
  <div>
    <div class="headline primary--text mb-3">Average Response Time</div>
    <v-layout :style="{ margin: '-8px' }" wrap>
      <v-flex v-for="(item, index) in items" :key="index" class="pa-2" xs12 md6>
        <v-card :style="{ height: '100%' }">
          <v-layout column :style="{ height: 'inherit' }">
            <v-flex shrink>
              <v-card-title class="resize-header">{{ item.text }}</v-card-title>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <v-card-text class="resize-value">
                <template v-if="loading">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </template>
                <template v-else>
                  {{ item.value }}
                </template>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    averageFirstResponseTime: {
      type: [Number, String],
      default: 0
    },
    averageResolvedTicketTime: {
      type: [Number, String],
      default: 0
    },
    received: {
      type: [Number, String],
      default: 0
    },
    resolved: {
      type: [Number, String],
      default: 0
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    items() {
      let averageFirstResponseTime = this.averageFirstResponseTime
      let averageResolvedTicketTime = this.averageResolvedTicketTime

      return [
        { text: 'Received', value: this.received },
        { text: 'Resolved', value: this.resolved },
        {
          text: 'Average first response time',
          value: `${this.toTimer(Math.floor(averageFirstResponseTime))}`
        },
        {
          text: 'Average resolved ticket time',
          value: `${this.toTimer(Math.floor(averageResolvedTicketTime))}`
        }
      ]
    }
  },
  methods: {
    toTimer: (value) => {
      let totalSeconds = value
      if (typeof totalSeconds == 'string') {
        totalSeconds = parseInt(totalSeconds)
      }
      const seconds = Math.floor(totalSeconds) % 60
      const minutes = Math.floor(totalSeconds / 60) % 60
      const hours = Math.floor(totalSeconds / 60 / 60)
      const padZero = (number) => (number > 99 ? number : number.toString().padStart(2, '0'))
      return `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`
    }
  }
}
</script>
<style lang="css" scoped>
/* .resize-header {
  font-size: 16px !important;
  font-weight: 400;
}
.resize-value {
  font-size: 24px !important;
  line-height: 32px !important;
}
@media screen and (min-width: 1560px) { */
.resize-header {
  font-size: 24px !important;
}
.resize-value {
  font-size: 42px !important;
  font-weight: bold !important;
}
/* } */
</style>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Overview/ResponseStatistics.vue